

import React from 'react';

import TabPanel from './TabPanel';
import UserPanel from './UserPanel';

const renderTabPanelUser = (props) => {
    return (
        <TabPanel key={props.name} name={props.name} iconName={props.iconName} title={props.title}>
            <UserPanel />
        </TabPanel>
    );
}

export default renderTabPanelUser;
